module.exports = __webpack_public_path__ + "img/arrow-down-purple.2d677cf9.svg";